import React from 'react';
import ReactDOM from 'react-dom';
//import axios from 'axios';
import './Assets/Styles/index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { register, onServiceWorkerUpdate  } from './registerServiceWorker';
import { AuthLogin } from './AuthComponents/AuthLogin';

// Register service worker
register();

// Handle updates
onServiceWorkerUpdate().then(() => {
  console.log('New content will be available after refresh');
  // Optional: Show UI update notification here
});


ReactDOM.render(
  <AuthLogin>
    <App />
  </AuthLogin>
    ,document.getElementById('root'));

